import React, { useCallback, useEffect, useState } from 'react';
import { numaraylaGetir } from './SoruSatisi';
import { DURUM_ETIKET, numaraKopyala } from './musteri/MusteriSiparisler';

// ============================================================================
// MÜŞTERİ SİPARİŞLERİ — yönetici ekranı (2026-10-26, kullanıcı kararı "ayrılsın, yönetici işlesin").
// Müşterinin siparişi sorularını başka müşterilere ve başka yayınevinin basımına kapatır (ayrılık);
// "Satışa işle" siparişi müşterinin yayınevine SATIŞ kaydına çevirir (Satış Arşivi'nde görünür,
// satış kilidi devreye girer), "İptal" soruları havuza döndürür. Kayıt silinmez.
// Uçlar: GET /api/musteri/yonetim/siparisler?durum= · POST …/:id/isle {birim_fiyat?} · POST …/:id/iptal {neden}
// ============================================================================
const tarih = (t) => (t ? new Date(t).toLocaleString('tr-TR', { dateStyle: 'medium', timeStyle: 'short' }) : '');

export default function MusteriSiparisYonetimi({ apiUrl, authFetch, onGeri, onBasimaGonder }) {
  const [durum, setDurum] = useState('beklemede');
  const [liste, setListe] = useState(null);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');
  const [islem, setIslem] = useState(null);   // { id, tur: 'isle'|'iptal', deger }
  const [mesgul, setMesgul] = useState(false);

  const yukle = useCallback(async () => {
    setHata('');
    try {
      const r = await authFetch(`${apiUrl}/api/musteri/yonetim/siparisler?durum=${durum}`);
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.hata || `Liste alınamadı (HTTP ${r.status})`);
      setListe(d.siparisler || []);
    } catch (e) {
      setHata(e.message); setListe([]);
    }
  }, [apiUrl, authFetch, durum]);
  useEffect(() => { setListe(null); yukle(); }, [yukle]);

  const gonder = async (s) => {
    setMesgul(true); setHata(''); setBilgi('');
    const yol = `${apiUrl}/api/musteri/yonetim/siparisler/${s.id}/${islem.tur}`;
    const govde = islem.tur === 'isle'
      ? (String(islem.deger || '').trim() ? { birim_fiyat: Number(String(islem.deger).replace(',', '.')) } : {})
      : { neden: String(islem.deger || '').trim() };
    try {
      const r = await authFetch(yol, { method: 'POST', body: JSON.stringify(govde) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || d.basarili === false) {
        // satisServisi.basimKaydiYaz reddi: uygun_degil [{public_no, neden}] + engel (başka alıcı) [{public_no}].
        const sorunlu = [...(Array.isArray(d.uygun_degil) ? d.uygun_degil : []), ...(Array.isArray(d.engel) ? d.engel : [])];
        const ek = sorunlu.length ? ` — ${sorunlu.map((u) => `#${u.public_no}${u.neden ? ` (${u.neden})` : ''}`).join(', ')}` : '';
        throw new Error((d.hata || `İşlem başarısız (HTTP ${r.status})`) + ek);
      }
      setBilgi(islem.tur === 'isle'
        ? `${s.siparis_no} satışa işlendi — ${s.yayinevi_ad || 'alıcı'} adına ${s.numaralar.length} soru Satış Arşivi'ne yazıldı.`
        : `${s.siparis_no} iptal edildi — sorular havuza döndü.`);
      setIslem(null);
      await yukle();
    } catch (e) {
      setHata(e.message);
    }
    setMesgul(false);
  };

  const basima = async (s) => {
    setHata('');
    try {
      const d = await numaraylaGetir(apiUrl, authFetch, s.numaralar);
      const sira = new Map(s.numaralar.map((n, i) => [n, i]));
      const ids = [...d.sorular].sort((a, b) => sira.get(a.public_no) - sira.get(b.public_no)).map((x) => x.id);
      if (!ids.length) throw new Error('Siparişin soruları bulunamadı');
      onBasimaGonder({ ids, yayineviId: s.yayinevi_id != null ? Number(s.yayinevi_id) : null, yayineviAd: s.yayinevi_ad || '' });
    } catch (e) {
      setHata(e.message);
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-3">
      <div className="flex flex-wrap items-center gap-3">
        <button type="button" onClick={onGeri} className="px-3 py-1.5 text-xs border border-gray-300 rounded-lg hover:bg-gray-50">← Geri</button>
        <h2 className="text-lg font-bold text-gray-800">🧾 Müşteri Siparişleri</h2>
        <div className="flex gap-1 ml-auto">
          {['beklemede', 'islendi', 'iptal', 'tumu'].map((d) => (
            <button key={d} type="button" data-siparis-durum={d} aria-pressed={durum === d} onClick={() => setDurum(d)}
              className={`px-2.5 py-1 rounded text-xs font-semibold ${durum === d ? 'bg-blue-600 text-white' : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'}`}>
              {d === 'tumu' ? 'Tümü' : DURUM_ETIKET[d].ad}
            </button>
          ))}
        </div>
      </div>
      {hata && <div data-yonetim-hata className="p-3 rounded-lg border border-red-300 bg-red-50 text-sm text-red-700">{hata}</div>}
      {bilgi && <div data-yonetim-bilgi className="p-3 rounded-lg border border-green-300 bg-green-50 text-sm text-green-800">{bilgi}</div>}
      {liste === null ? (
        <div className="py-8 text-center text-sm text-gray-400">Yükleniyor…</div>
      ) : liste.length === 0 ? (
        <div className="p-8 text-center text-sm text-gray-500 bg-white rounded-xl border border-gray-200">Bu durumda sipariş yok.</div>
      ) : liste.map((s) => {
        const d = DURUM_ETIKET[s.durum] || { ad: s.durum, sinif: 'bg-gray-100' };
        const acik = islem && islem.id === s.id;
        return (
          <section key={s.id} data-yonetim-siparis={s.siparis_no} className="bg-white border border-gray-200 rounded-xl p-3 space-y-2">
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <span className="font-mono font-bold">{s.siparis_no}</span>
              <span className={`px-1.5 py-0.5 rounded text-xs font-semibold ${d.sinif}`}>{d.ad}</span>
              <span className="text-gray-700">{s.musteri_ad}</span>
              <span className="text-xs text-gray-500">{s.musteri_email}</span>
              <span className="text-xs text-gray-500">· alıcı: <b>{s.yayinevi_ad || '—'}</b></span>
              <span className="text-xs text-gray-500">· {tarih(s.olusturma)}</span>
              <span className="text-xs text-gray-500">· {s.numaralar.length} soru</span>
            </div>
            <div className="font-mono text-xs bg-gray-50 border border-gray-200 rounded p-2 break-words select-all">{s.numaralar.join(', ')}</div>
            {s.musteri_notu && <div className="text-xs text-gray-600">Müşteri notu: {s.musteri_notu}</div>}
            {s.durum === 'islendi' && (
              <div className="text-xs text-gray-600">İşleyen: {s.isleyen_email || '—'} · {tarih(s.islenme)}{s.birim_fiyat != null ? ` · birim fiyat ${s.birim_fiyat}` : ''}</div>
            )}
            {s.durum === 'iptal' && s.iptal_nedeni && <div className="text-xs text-gray-600">İptal nedeni: {s.iptal_nedeni}</div>}
            <div className="flex flex-wrap gap-2">
              <button type="button" onClick={() => numaraKopyala(s.numaralar)} className="px-2.5 py-1 rounded border border-gray-300 text-xs hover:bg-gray-50">Numaraları kopyala</button>
              {onBasimaGonder && s.durum !== 'iptal' && (
                <button type="button" data-basima-gonder={s.siparis_no} onClick={() => basima(s)}
                  className="px-2.5 py-1 rounded border border-gray-300 text-xs hover:bg-gray-50">Basım'a gönder</button>
              )}
              {s.durum === 'beklemede' && (
                <>
                  <button type="button" data-siparis-isle={s.siparis_no} onClick={() => setIslem({ id: s.id, tur: 'isle', deger: '' })}
                    className="px-2.5 py-1 rounded bg-green-600 text-white text-xs font-semibold hover:bg-green-700">Satışa işle</button>
                  <button type="button" data-siparis-iptal={s.siparis_no} onClick={() => setIslem({ id: s.id, tur: 'iptal', deger: '' })}
                    className="px-2.5 py-1 rounded border border-red-300 text-red-700 text-xs hover:bg-red-50">İptal</button>
                </>
              )}
            </div>
            {acik && (
              <form className="flex flex-wrap items-center gap-2 p-2 rounded bg-gray-50 border border-gray-200"
                onSubmit={(e) => { e.preventDefault(); gonder(s); }}>
                {islem.tur === 'isle' ? (
                  <label className="text-xs text-gray-600 flex items-center gap-1.5">
                    Birim fiyat (isteğe bağlı):
                    <input data-birim-fiyat inputMode="decimal" value={islem.deger} onChange={(e) => setIslem({ ...islem, deger: e.target.value })}
                      className="px-2 py-1 border border-gray-300 rounded text-xs w-24" placeholder="boş = sonra" />
                  </label>
                ) : (
                  <label className="text-xs text-gray-600 flex items-center gap-1.5 flex-1">
                    İptal nedeni:
                    <input data-iptal-nedeni value={islem.deger} onChange={(e) => setIslem({ ...islem, deger: e.target.value })}
                      className="px-2 py-1 border border-gray-300 rounded text-xs flex-1" placeholder="en az 3 karakter" />
                  </label>
                )}
                <button type="submit" disabled={mesgul || (islem.tur === 'iptal' && String(islem.deger).trim().length < 3)}
                  className="px-2.5 py-1 rounded bg-blue-600 text-white text-xs font-semibold disabled:opacity-50">
                  {islem.tur === 'isle' ? 'Satışı kaydet' : 'İptal et'}
                </button>
                <button type="button" onClick={() => setIslem(null)} className="px-2.5 py-1 rounded border border-gray-300 text-xs">Vazgeç</button>
              </form>
            )}
          </section>
        );
      })}
    </div>
  );
}
